export default __webpack_public_path__ + "static/media/socials.368a5692.svg";